import { adminModuleQuery, useModule } from 'system/structure-modules';

export default function AdminEmailPreviewScreen() {
    const { EmailPreviewScreen } = useModule(adminModuleQuery);
    return <EmailPreviewScreen />;
}
